const translations = {
  layout: { Invoices: 'Faktury' },
};

export default translations;
